// Add your JS customizations here
AOS.init();

import "./modules/header"
import "./modules/footer"
import "./modules/animated-logo"
import "./modules/home-stats"
import "./modules/home-featured-projects"
import "./modules/home-feature-highlights"
import "./modules/team-spotlight"
import "./modules/photoslider"
import "./modules/block-stats"
import "./modules/global-hero"
import "./modules/single-related-people"
import "./modules/single-related-projects"
import "./modules/loadmore"
import "./modules/custom-select"
import "./modules/search-fields-wrapper"
import "./modules/filter-insights-ajax"
import "./modules/filter-projects-ajax"
import "./modules/search-people-ajax"
import "./modules/collapsible-content"
import "./modules/two-related-projects"
import "./modules/three-related-news"
import "./modules/three-related-people"
import "./modules/project-hero"
import "./modules/expand-block"
import "./modules/common"
